import React, { useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardContent, Typography, Grid, Pagination, Box } from "@mui/material";
import { fetchStocks } from "../../store/stockSlice";
import StockFilter from "../Filters/StockFilters";
import { formatQuantity } from "../../services/utils";
import { useNavigate } from "react-router-dom";
import MyTable from "../MyTable";
import { render } from "@testing-library/react";

const DisplayStocks = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()

  const { Stocks, pagination } = useSelector((state) => state.stock) || {}; // Accessing stock and pagination data
  const { sales, selectedSale } = useSelector((state) => state.sale) || {};
  const { selectedShop } = useSelector((state) => state.shop) || {};

  
  // const handlePageChange = (event, value) => {
  //   if (value >= 1 && value <= pagination.totalPages) {
  //     setPage(value);
  //   }
  // };

  const handlePageChange = (newPage, newRowsPerPage) => {
    
    dispatch(fetchStocks({ shop: selectedShop?._id, page: newPage+1, limit: newRowsPerPage }));
  };
  
  useEffect(() => {
    if (selectedShop) {
      dispatch(fetchStocks({ shop: selectedShop?._id, page:1, limit: 5 }));
    }
  }, [selectedShop, dispatch]);
  
  useEffect(() => {
    if (sales || selectedSale) {
      if (selectedShop) {
        dispatch(fetchStocks({ shop: selectedShop?._id, page:1, pageSize: 5 }));
      }
    }
  }, [sales, selectedSale, selectedShop, dispatch]);
  
 const goToDetails=(article_id)=>{
        navigate(`/MouvementStock/${article_id}`)
 }

  const getBackgroundColor = (stock) => {
    const securityStock = stock?.article?.securityStock || 0;
    const totalQuantity = stock?.totalQuantity || 0;
    const margin = securityStock * 0.1; // Calculate 10% of security stock

    if (totalQuantity > securityStock + margin) {
      return "linear-gradient(to right, #56ab2f, #a8e063)"; // Green gradient
    } else if (totalQuantity >= securityStock && totalQuantity <= securityStock + margin) {
      return "linear-gradient(to right, #ffb347, #ffcc33)"; // Orange gradient
    } else if (totalQuantity < securityStock) {
      return "linear-gradient(to right, #ff6b6b, #ff4757)"; // Red gradient
    }
    return "transparent"; // Default
  };
const headers = [
  { key: "article.name", 
    label: "Article",
    render: (row) => (
      row.article?.name || "N/A"
    
    )},
    
  { key: "totalQuantity", 
    label: "Total Quantity",
    render: (row) => (
      <Box
        sx={{
          background: getBackgroundColor(row),
          color: "white",
          borderRadius: "4px",
          transition: "transform 0.3s, box-shadow 0.3s",
          display: "flex", // To prevent full width background
          justifyContent: "center",
        }}
      >
        {formatQuantity({
                      isVenteDetail: row?.article?.isAlowSecondaryUnit,
                      quantity: row?.totalQuantity,
                      nombreDePiece: row?.article?.unitsQte,
                      primaryUnit: row?.article?.primaryUnits,
                      secondaryUnit: row?.article?.secondaryUnits,
                    })}
        
      </Box>
    )},
  
]

const actions = [
  {
    label: "View Details",
    callback: (row) => {
       goToDetails(row.article._id);
    
    },
  },  
] 
const printOptions= {
  title: `Stock ${selectedShop? selectedShop.name : "Generale"}`,
  paperHeader: {
    
  },
  landscape: true
}


  return (
    <div>
      <h2>Stocks</h2>
      <div style={{marginBottom: "20px"}}>
        <StockFilter />
      </div>

      {/* <Grid container spacing={2}>
        {Stocks?.length > 0 ? (
          Stocks.map((stockItem, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  background: getBackgroundColor(stockItem),
                  color: "white",
                  transition: "transform 0.3s, box-shadow 0.3s",
                  ":hover": {
                    transform: "scale(1.05)",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                  },
                }}
              >
                <CardContent onClick={()=>{goToDetails(stockItem.article._id)}}>
                  <Typography variant="h5" component="div">
                    {stockItem.article.name}
                  </Typography>
                  <Typography variant="body2" color="inherit">
                    Quantity:{" "}
                    {formatQuantity({
                      isVenteDetail: stockItem?.article?.isAlowSecondaryUnit,
                      quantity: stockItem?.totalQuantity,
                      nombreDePiece: stockItem?.article?.unitsQte,
                      primaryUnit: stockItem?.article?.primaryUnits,
                      secondaryUnit: stockItem?.article?.secondaryUnits,
                    })}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Typography variant="body2" color="textSecondary">
            No stocks available
          </Typography>
        )}
      </Grid>

       
      <Grid container justifyContent="center" marginTop={2}>
  <Pagination
    count={pagination ? pagination.totalPages : 1} // Total pages
    page={page} // Current page from state
    onChange={handlePageChange} // This will update the page value on click
    color="primary"
  />
</Grid>  */}

      <MyTable 
        headers={headers}
        totalRows={pagination?.total || 0}
        data={Stocks}
        actions={actions}
        defaultPageSize={5}
        onPageChange={handlePageChange}
        printOptions={printOptions}
      
      />
    </div>
  );
};

export default DisplayStocks;
